import { Draft, produce } from 'immer';

import {
  TEMPLATE_ATTACHMENT_CLEAR,
  TEMPLATE_ATTACHMENT_SAVE,
  TEMPLATE_CLEAR_ALL_STATE,
  TEMPLATE_INFORMATION_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import {
  scheduledDocumentPreviewDataFetched,
  setTemplateParticipants,
  setupTemplateByDraft,
  TemplateAction,
} from '@app/store/template/actions';
import AttachmentRequest from '@app/store/template/AttachmentRequest';

export interface TemplateAttachment {
  participantId: string;
  requests: AttachmentRequest[];
}

export type TemplateAttachmentState = TemplateAttachment[];

const initialState: TemplateAttachmentState = [];

const reducer = produce((draft: Draft<TemplateAttachmentState>, action: TemplateAction) => {
  switch (action.type) {
    case TEMPLATE_ATTACHMENT_CLEAR:
    case TEMPLATE_CLEAR_ALL_STATE:
      return initialState;

    case TEMPLATE_ATTACHMENT_SAVE: {
      const { participantId, requests } = action.payload;
      const attachments = {
        participantId,
        requests,
      };
      const index = draft.findIndex((item) => item.participantId === participantId);

      if (index === -1) {
        draft.push(attachments);
      } else {
        draft[index] = attachments;
      }
      return draft;
    }

    case TEMPLATE_INFORMATION_FETCH_SUCCESS: {
      const { participants } = action.payload;
      participants.forEach((participant) => {
        const { attachmentRequests, id: participantId } = participant;
        if (participantId) {
          draft.push({
            participantId,
            requests: attachmentRequests.map(
              ({ attachmentType, dataLabel, message, required }) => ({
                attachmentType,
                dataLabel,
                message,
                required,
              })
            ),
          });
        }
      });
      return draft;
    }
    case setupTemplateByDraft.type: {
      action.payload.participants.forEach((participant) => {
        draft.push({
          participantId: participant.id,
          requests: participant.attachmentRequests.map((request) => ({
            attachmentType: request.name,
            dataLabel: request.dataLabel,
            message: request.message,
            required: request.required,
          })),
        });
      });
      return draft;
    }
    case setTemplateParticipants.type: {
      const participantIds = action.payload.map((participant) => participant.id);
      return draft.filter((at) => participantIds.includes(at.participantId));
    }
    case scheduledDocumentPreviewDataFetched.type: {
      return action.payload.participants.map((participant) => ({
        participantId: participant.id,
        requests: participant.attachmentRequests,
      }));
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
